import React from "react";
import { Button, Card } from "react-bootstrap";
import { useAuth } from "../providers/AuthProvider";

/**
 * FrozenStudentGate — pantalla para un estudiante registrado por encima del
 * límite del plan de su academia. Puede iniciar sesión pero no operar hasta que
 * la academia amplíe su capacidad (momento en que se reactiva automáticamente).
 */
function FrozenStudentGate() {
  const { user, logout } = useAuth();

  return (
    <div
      className="d-flex align-items-center justify-content-center p-3"
      style={{ minHeight: "100vh", background: "var(--kp-bg, #f4f2f7)" }}
    >
      <Card className="border-0 shadow-sm" style={{ maxWidth: 480 }}>
        <Card.Body className="text-center p-4 p-md-5">
          <div style={{ fontSize: "3rem", lineHeight: 1 }}>
            <i className="mdi mdi-clock-alert-outline text-warning" aria-hidden="true" />
          </div>
          <h4 className="mt-3 mb-2">Tu cuenta está en espera</h4>
          <p className="text-muted mb-4">
            {user?.name ? `Hola, ${user.name}. ` : ""}
            Tu academia alcanzó el número máximo de estudiantes de su plan, así que
            tu cuenta quedó <strong>en espera de capacidad</strong>. Aún no puedes
            agendar clases ni acceder a tu espacio.
          </p>
          <p className="text-muted small mb-4">
            Se activará <strong>automáticamente</strong> en cuanto la academia
            amplíe su capacidad. Ya le avisamos; si tienes dudas, contáctala
            directamente.
          </p>
          <Button variant="outline-secondary" onClick={logout} style={{ minHeight: 44 }}>
            Cerrar sesión
          </Button>
        </Card.Body>
      </Card>
    </div>
  );
}

export { FrozenStudentGate };
